import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../api";
import { useAuth } from "../App";

const ACTION_LABELS = {
  leave_created: "Demande créée",
  leave_approved: "Demande approuvée",
  leave_refused: "Demande refusée",
  leave_deleted: "Demande annulée",
  user_created: "Compte créé",
  user_deleted: "Compte supprimé",
};

const ACTION_COLORS = {
  leave_created: { bg: "#EEEDFE", color: "#7C6FE0" },
  leave_approved: { bg: "#EAF3DE", color: "#3B6D11" },
  leave_refused: { bg: "#FCEBEB", color: "#A32D2D" },
  leave_deleted: { bg: "#FAEEDA", color: "#854F0B" },
  user_created: { bg: "#E6F1FB", color: "#185FA5" },
  user_deleted: { bg: "#FCEBEB", color: "#A32D2D" },
};

function AuditLog() {
  const { token } = useAuth();
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    axios.get(API + "/users/audit-logs", {
      headers: { Authorization: "Bearer " + token }
    }).then(r => setLogs(r.data)).catch(err => console.error(err));
  }, [token]);

  const filtered = logs.filter(l => {
    const name = ((l.prenom || "") + " " + (l.nom || "")).toLowerCase();
    const matchSearch = search === "" || name.includes(search.toLowerCase()) || l.action.includes(search.toLowerCase());
    const matchFilter = filter === "all" || l.action.startsWith(filter);
    return matchSearch && matchFilter;
  });

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
        <h2 style={{ margin: 0, fontWeight: 500 }}>Journal d'activité</h2>
        <div style={{ display: "flex", gap: 8 }}>
          <select value={filter} onChange={e => setFilter(e.target.value)}
            style={{ padding: "7px 10px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13 }}>
            <option value="all">Toutes les actions</option>
            <option value="leave">Congés</option>
            <option value="user">Comptes</option>
          </select>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher..."
            style={{ padding: "7px 12px", border: "1px solid #ddd", borderRadius: 6, fontSize: 13, width: 180 }} />
        </div>
      </div>

      <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: 10, padding: 16 }}>
        {filtered.length === 0 ? (
          <div style={{ fontSize: 13, color: "#888" }}>Aucune entrée trouvée.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>
                {["Date", "Utilisateur", "Action", "Détails"].map(h => (
                  <th key={h} style={{ textAlign: "left", padding: "6px 10px", fontSize: 11, color: "#888", borderBottom: "1px solid #eee" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(l => {
                const style = ACTION_COLORS[l.action] || { bg: "#f5f5f5", color: "#555" };
                const label = ACTION_LABELS[l.action] || l.action;
                const details = l.details || {};
                let detailStr = "";
                if (details.type) detailStr += details.type + " ";
                if (details.jours) detailStr += details.jours + "j ";
                if (details.date_debut) detailStr += new Date(details.date_debut).toLocaleDateString("fr-FR");
                if (details.email) detailStr += details.email;
                if (details.role) detailStr += " (" + details.role + ")";
                return (
                  <tr key={l.id}>
                    <td style={td}>{new Date(l.created_at).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" })}</td>
                    <td style={td}>{l.prenom} {l.nom}</td>
                    <td style={td}>
                      <span style={{ background: style.bg, color: style.color, padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 500 }}>
                        {label}
                      </span>
                    </td>
                    <td style={{ ...td, color: "#888", fontSize: 12 }}>{detailStr || "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const td = { padding: "8px 10px", borderBottom: "1px solid #f5f5f5" };

export default AuditLog;
